/* eslint-disable header/header */
export const name = "@azure/msal-browser";
export const version = "3.20.0";
